import { Typography } from "@mui/material";
import * as Yup from "yup";

export const initialValues = (data, optionTypes) => {
  const values = {};

  data?.option_values?.forEach((value) => {
    values[value?.option_type_id] = value?.id;
  });

  const types = {};
  optionTypes.forEach((option) => {
    types[option?.name] = values[option?.id];
  });

  return {
    ...data,
    ...types,
    images: data?.media?.map((image) => image.url),
  };
};

export const structure = (prepareOptionTypes, t) => {
  let optionTypes = prepareOptionTypes();
  return [
    {
      head: "",
      width: "100%",
      list: [
        {
          width: "100%",
          name: `images`,
          kind: "multiUpload",
          id: "images",
          type: "image",
          label: (
            <Typography sx={{ fontsize: "16px", color: "#9F9F9F" }}>
              {t("products.label_variant_image")}{" "}
            </Typography>
          ),
        },
        ...optionTypes,
        {
          name: `sku`,
          kind: "input",
          type: "text",
          label: t("products.label_sku"),
          placeholder: t("products.label_sku"),
          width: "100%",
        },
        {
          name: `price`,
          kind: "input",
          type: "number",
          label: t("products.col_price"),
          width: "47%",
          placeholder: t("products.placeholder_write_price"),
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>
              {t("products.curr_sar")}
            </p>
          ),
        },
        {
          name: `price_after_discount`,
          kind: "input",
          type: "number",
          label: t("products.col_price_after_discount"),
          width: "47%",
          placeholder: t("products.placeholder_write_price"),
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>
              {t("products.curr_sar")}
            </p>
          ),
        },
        {
          name: `width`,
          kind: "input",
          type: "text",
          label: `${t("products.label_width")}*`,
          width: "47%",
          placeholder: t("products.label_width"),
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>
              {t("products.unit_cm")}
            </p>
          ),
        },
        {
          name: `height`,
          kind: "input",
          type: "text",
          label: `${t("products.label_height")}*`,
          placeholder: t("products.label_height"),
          width: "47%",
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>
              {t("products.unit_cm")}
            </p>
          ),
        },
        {
          name: `length`,
          kind: "input",
          type: "text",
          label: `${t("products.label_length")}*`,
          placeholder: t("products.label_length"),
          width: "47%",
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>
              {t("products.unit_cm")}
            </p>
          ),
        },
        {
          name: `weight`,
          kind: "input",
          type: "text",
          label: `${t("products.label_weight")}*`,
          placeholder: t("products.label_weight"),
          width: "47%",
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>
              {t("products.unit_gm")}
            </p>
          ),
        },
        {
          name: `volume`,
          kind: "input",
          type: "text",
          label: t("products.label_volume"),
          placeholder: t("products.label_volume"),
          width: "47%",
          EndAdornment: (
            <p style={{ fontSize: "18px", color: "#1A1A1A" }}>
              m<sup style={{ fontSize: "12px" }}>3</sup>
            </p>
          ),
        },
      ],
    },
  ];
};

export const validationSchema = (optionTypesFilter, t) => {
  let types = {};
  optionTypesFilter?.forEach((option) => {
    types[option?.name] = Yup.string().required(t("vendors.error_required"));
  });
  return Yup.object({
    ...types,
    images: Yup.array(),
    sku: Yup.string(),
    width: Yup.number().required(t("vendors.error_required")),
    height: Yup.number().required(t("vendors.error_required")),
    length: Yup.number().required(t("vendors.error_required")),
    weight: Yup.number().required(t("vendors.error_required")),
    volume: Yup.number(),
    price: Yup.number(),
    price_after_discount: Yup.number()
      .typeError(t("products.error_invalid_price"))
      .nullable()
      .test(
        "is-greater",
        t("products.error_price_after_discount_min"),
        function (value) {
          const { price } = this.parent;
          if (value == null) {
            return true; // Allow empty price_after_discount
          }
          return value <= price;
        },
      ),
  });
};
